const segmentGutter = 8;
const barMinHeight = 24;

export const tokens = {
    colors: {
        statusBase: '#ffe922',
        statusMedian: '#AA039FFF',
        statusNegative: '#ff0f00',
        statusNeutral: '#ff7222',
        statusPositive: '#1dff26',
    },
    zIndex: {
        tick: 1,
        lifted: 2,
        action: 1,
        status: 2,
        pocket: 2,
        pocketContent: 3,
        thumbnail: 3,
        focusRing: 4,
    },
    meter: {},
    segment: {
        gutter: segmentGutter,
    },
    bar: {
        minHeight: barMinHeight,
    },
    tick: {
        gapOffset: 2,
        // This is only applied when nested within a Segment.
        minWidth: 24,
        stroke: {
            width: 2,
            pulse: {
                from: 0.6,
                to: 1.6,
            },
        },
    },
    pocket: {
        count: {
            fontSize: 12,
        },
        // TODO: This needs to align exactly with the
        // `FloorActivity.PriceCard > padding`.
        offset: 12,
    },
    milestone: {
        gap: 2,
        price: {
            fontSize: 12,
        },
        code: {
            fontSize: 10,
        },
        // TODO: This needs to align exactly with the
        // `FloorActivity.PriceCard > padding`.
        stickyOffset: 12 * 2,
    },
    skeleton: {
        segment: {
            height: barMinHeight,
        },
        bar: {
            radius: 5,
        },
        milestone: {
            width: barMinHeight + segmentGutter,
            childHeight: barMinHeight / 2 - segmentGutter / 4,
            radius: 3,
        },
    },
};
